import * as React from 'react';
import { Translate } from 'react-localize-redux';
import ContactsV2 from '../../containers_v2/contact/Contacts';
import { Route } from '../Routes';

const ContactsRoutes = (): Route[] => [
	{
		component: ContactsV2,
		path: '/contacts-v2',
		name: <Translate id="contacts" />,
	}
];

export default ContactsRoutes;
